import type { IframePoolOfferOdds, VolatilityLevel } from '../../../../modules/api';
import { OddsStyleContent } from './OddsStyleContent';
import { SheetFrame } from '../../../../modules/design-system';

type Props = {
  odds: IframePoolOfferOdds;
  volatility: VolatilityLevel;
  onVolatilityChange: (level: VolatilityLevel) => void;
  onClose: () => void;
};

const TITLE_ID = 'odds-sheet-title';

/** Sleek's mobile odds picker: the pack-style content in a bottom sheet. */
export function OddsSheet({ odds, volatility, onVolatilityChange, onClose }: Props) {
  return (
    <SheetFrame
      onClose={onClose}
      ariaLabelledBy={TITLE_ID}
      inspectName="OddsSheet"
      panelClassName="bg-[var(--co-OddsSheet-background,#0E0F11)] [border-top-left-radius:var(--co-OddsSheet-borderRadius,24px)] [border-top-right-radius:var(--co-OddsSheet-borderRadius,24px)]"
      handleClassName="bg-[var(--co-OddsSheet-handle,#2F3037)]"
    >
      <OddsStyleContent
        odds={odds}
        volatility={volatility}
        onVolatilityChange={onVolatilityChange}
        onClose={onClose}
        titleId={TITLE_ID}
      />
    </SheetFrame>
  );
}
